import actionTypes from '@atom/actions/actionTypes';

export const updateWorkValidations = data => ({
  type: actionTypes.UPDATE_WORK_VALIDATIONS,
  data,
});
